import React from 'react';

interface SuccessMessageProps {
  onClose: () => void;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ onClose }) => {
  return (
    <div>
      {/* Header Section - Same as main form */}
      <section className="heading">
        <div className="container">
          <div className="row">
            <div className="main_banner">
              <img className="logo" src="/main_banner.png" alt="Logo" />
              <h1 className="width_remark" style={{ marginTop: 15, marginBottom: 50 }}>
                2025 智慧生活夥伴大獎<br />Application Form 參賽表格
              </h1>
            </div>
            <div className="logo-container">
              <div className="organiser">
                <p style={{ fontSize: 14, color: '#004FAD' }}><b>Organiser</b></p>
                <img className="etnet-logo" src="/etnet.png" width="100%" alt="Organiser" />
              </div>
              <div className="co-organiser">
                <p style={{ fontSize: 14, color: '#004FAD' }}><b>Co-organiser</b></p>
                <img className="cyberport-logo" src="/Cyberport_Logo.png" style={{ marginTop: '-6%' }} width="95%" alt="Co-organiser" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Success Content */}
      <section className="form_content">
        <div className="container">
          <div className="success-page-content">
            {/* Thank you message */}
            <div className="thank-you-message">
              <h2>感謝閣下參與！請密切留意結果公布。</h2>
              <p>Thank you for your participation! Please pay close attention to the results announcement.</p>
            </div>

            {/* Return button */}
            <div className="return-button-container">
              <button onClick={onClose} className="return-to-website-btn">
                Return to website 返回網站
              </button>
            </div>

            {/* Contact information */}
            <div className="contact-info">
              <p>
                Please note that applicant will receive an auto-reply email after submitting the application successfully.
                If you don't receive any reply email 3 days after your submission, please contact (+852) 2880 2978,
                or email <a href="mailto:smartcityawards@etnet.com.hk">smartcityawards@etnet.com.hk</a>
              </p>
              <p>
                請注意如成功申請後應會收到一封自動回覆的電子郵件。如閣下在3天內未能收到，請致電 (+852) 2880 2978，
                或電郵 <a href="mailto:smartcityawards@etnet.com.hk">smartcityawards@etnet.com.hk</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SuccessMessage;